import { spawn, call, put, takeLatest } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import { reportActions } from '../../../application/actions/report';
import api from '../../api/index';

const apiRequest = api(process.env.REACT_APP_HOST);

// GETBYIDDONWLOAD
export function* reportDonwloadFetch(e) {
    yield put(reportActions.conexionReportDonwload({ connection: true }));
    try {


        const params = e.payload;
        const url = `report/${params.resource}/${params.estado}`
        const response = yield call(
            apiRequest.get,
            url,
            null,
            null,
            true
        );

        // Extraigo todos los datos
        console.log(response.byteLength)
        if (response.byteLength > 100) {
            yield put(reportActions.reportDonwload({ result: true, buffer: response }));
        }else{
            yield put(reportActions.errorgReportDonwload({ error: true, message: 'error al cargar el archivo'}));
        }


    } catch (err) {
        yield put(reportActions.errorgReportDonwload({ error: true, message: err.message }));
    } finally {
        yield put(reportActions.conexionReportDonwload({ connection: false }));
    }
}



export function* watchFetchReport() {
    yield takeLatest(reportActionsSaga.reportDonwload.type, reportDonwloadFetch);

}

export default function* rootSaga() {
    yield spawn(watchFetchReport);
}

const reportDonwload = createAction('reportSaga/reportDonwload');

export const reportActionsSaga = {
    reportDonwload
};
